interface SubmissionInitiatedIconProps {
  width?: string;
  height?: string;
}

const SubmissionInitiatedIcon = (props: SubmissionInitiatedIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "50"}
      height={props.height || "48"}
      viewBox="0 0 50 48"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.7734 5H2.16732C1.39957 5 0.773438 5.511 0.773438 6.13758V46.8624C0.773438 47.489 1.39957 48 2.16732 48H31.7734C32.878 48 33.7734 47.1046 33.7734 46V5Z"
        fill="#D7CDB0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.8373 42.9204H6.2136C5.58818 42.9204 5.07812 42.4103 5.07812 41.7849V1.13547C5.07812 0.510054 5.58818 0 6.2136 0H31.5234C31.8361 0 32.1052 0.111503 32.3263 0.33258L38.6401 6.64649C38.8611 6.86756 38.9727 7.13667 38.9727 7.44938V41.785C38.9728 42.4103 38.4626 42.9204 37.8373 42.9204Z"
        fill="#FBEED0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9961 0.09375V5.8389C31.9961 6.46432 32.5061 6.97437 33.1316 6.97437H38.8767C38.8216 6.85378 38.7435 6.74285 38.6426 6.64179L32.3288 0.327884C32.2277 0.226827 32.1167 0.148707 31.9961 0.09375Z"
        fill="#D7CDB0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7761 34.773C13.149 34.773 12.6406 34.2647 12.6406 33.6375C12.6406 33.0104 13.149 32.5021 13.7761 32.5021H29.4381C30.0652 32.5021 30.5736 33.0104 30.5736 33.6375C30.5736 34.2647 30.0652 34.773 29.4381 34.773H13.7761ZM13.7761 13.1225C13.149 13.1225 12.6406 12.6142 12.6406 11.987C12.6406 11.3599 13.149 10.8516 13.7761 10.8516H29.4381C30.0652 10.8516 30.5736 11.3599 30.5736 11.987C30.5736 12.6142 30.0652 13.1225 29.4381 13.1225H13.7761ZM13.7761 20.3393C13.149 20.3393 12.6406 19.831 12.6406 19.2039C12.6406 18.5767 13.149 18.0684 13.7761 18.0684H29.4381C30.0652 18.0684 30.5736 18.5767 30.5736 19.2039C30.5736 19.831 30.0652 20.3393 29.4381 20.3393H13.7761ZM13.7761 27.5562C13.149 27.5562 12.6406 27.0478 12.6406 26.4207C12.6406 25.7936 13.149 25.2852 13.7761 25.2852H29.4381C30.0652 25.2852 30.5736 25.7936 30.5736 26.4207C30.5736 27.0478 30.0652 27.5562 29.4381 27.5562H13.7761Z"
        fill="#515151"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5248 37.537V39.4917C40.5248 39.7202 40.6512 39.9155 40.8596 40.0093C41.0679 40.1031 41.2981 40.068 41.4691 39.9164L48.8449 33.3803C49.0969 33.157 49.2273 32.8672 49.2273 32.5305C49.2273 32.1939 49.0969 31.9041 48.8449 31.6808L41.4691 25.1446C41.2981 24.9931 41.0679 24.9581 40.8596 25.0518C40.6512 25.1455 40.5248 25.341 40.5248 25.5694V28.2511C29.2331 28.2511 24.2891 31.8302 24.2891 45.3129C26.9648 38.4951 31.7195 37.537 40.5248 37.537Z"
        fill="#316EDF"
      />
    </svg>
  );
};

export default SubmissionInitiatedIcon;
